import Header from './header'
import Form_Container from './form-container'
import Instructions from './form-instructions'
import 'bootstrap/dist/css/bootstrap.css?rnd23adfdsdfsdffdfdsfsdfdfsddfdf=sdfefdfdf3asfas';
import TFForm from './typeform-card'
import CallToAction from './call-to-action'
import InstructionsContainer from './form-instructions2?rnd=1';
import InstructionsMobile from './instruction-mobile'
import Footer from './footer'
import PropsCheck from './propscheck'


function App() {
  
  return (
    <div className="App">
      
      <Header />
      <Form_Container />
      {/* <InstructionsMobile /> */}
      {/* <hr style={{paddingBottom: '50px'}} /> */}
      <Footer />
      
     <InstructionsContainer />
    </div>
  );
}

export default App;
